module.exports = __webpack_public_path__ + "img/business-5.4bd12817.png";